import { render } from "./FeaturedPools.vue?vue&type=template&id=a5da2c1a&ts=true"
import script from "./FeaturedPools.vue?vue&type=script&lang=ts"
export * from "./FeaturedPools.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__